/**
 * abilityTable — the per-ability "damage blocked" table.
 *
 * One renderer for two callers, like weaponTable: the account screen's
 * lifetime figures and the end-of-match recap's this-match figures. Both
 * arrive in the same shape ({ abilityId, name, damageBlocked }), already sorted
 * by damage with a server-resolved name, so this never sorts and never looks a
 * name up. Pure DOM out, no fetching and no state.
 */

const COLUMNS = ['Ability', 'Damage blocked'];

/**
 * @param {Array<{abilityId: string, name?: string, damageBlocked: number}>} abilities
 * @param {{emptyMessage?: string}} [options]
 * @returns {HTMLElement} a wrapper holding either the table or an empty-state line
 */
export function renderAbilityTable(abilities, { emptyMessage = 'No damage blocked yet.' } = {}) {
  const wrap = document.createElement('div');
  wrap.className = 'ability-table-wrap';

  const rows = Array.isArray(abilities) ? abilities : [];
  if (rows.length === 0) {
    const empty = document.createElement('div');
    empty.className = 'stat-empty';
    empty.textContent = emptyMessage;
    wrap.appendChild(empty);
    return wrap;
  }

  const table = document.createElement('table');
  table.className = 'stat-table ability-table';

  const thead = document.createElement('thead');
  const headRow = document.createElement('tr');
  for (const label of COLUMNS) {
    const th = document.createElement('th');
    th.scope = 'col';
    th.textContent = label;
    headRow.appendChild(th);
  }
  thead.appendChild(headRow);

  const tbody = document.createElement('tbody');
  for (const a of rows) {
    const tr = document.createElement('tr');
    tr.dataset.abilityId = a.abilityId || '';
    for (const value of [a.name || a.abilityId || '', Math.round(a.damageBlocked || 0)]) {
      const td = document.createElement('td');
      td.textContent = String(value);       // server-resolved copy, rendered as text
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }

  table.append(thead, tbody);
  wrap.appendChild(table);
  return wrap;
}
